import eventBus, { EVENT } from '@utils/event-bus';
/**
 * 统一的消息通知中心
 *
 * 替代原来分散在 DependencyLoader 中的三套通知机制
 * (SyncHook / callback 数组 / EventBus 监听)
 */
class Notifier {
    progressCallbacks = [];
    depsChangedCallbacks = [];
    listening = false;
    onProgress(callback) {
        this.ensureListening();
        this.progressCallbacks.push(callback);
    }
    offProgress(callback) {
        this.progressCallbacks = this.progressCallbacks.filter(cb => cb !== callback);
    }
    emitProgress(progress) {
        this.progressCallbacks.forEach((cb) => {
            cb(progress);
        });
    }
    onDepsChanged(callback) {
        this.depsChangedCallbacks.push(callback);
    }
    offDepsChanged(callback) {
        this.depsChangedCallbacks = this.depsChangedCallbacks.filter(cb => cb !== callback);
    }
    emitDepsChanged(info) {
        this.depsChangedCallbacks.forEach((cb) => {
            cb(info);
        });
    }
    ensureListening() {
        if (this.listening)
            return;
        this.listening = true;
        eventBus.on(EVENT.updateDepLoaderState, (progress) => {
            this.emitProgress(progress);
        });
    }
}
const notifier = new Notifier();
export default notifier;
